import EventDispatcher from "@/events/EventDispatcher";
import AppEvent from "@/events/AppEvent";

export default class MusicSound extends EventDispatcher {
  public audio: HTMLAudioElement;
  public isLoaded: boolean = false;
  
  protected basisVolume: number = 1;
  protected buffered: number = 0;
  protected _volume: number = 1;
  
  constructor(src: string, basisVolume: number = 1) {
    super();
    this.audio = new Audio(src);
    this.basisVolume = basisVolume;
    this.audio.volume = this.basisVolume * this._volume;
  }
  
  public load (): void {
    this.audio.load();
    if (this.audio.readyState === 4) {
      console.log('Music Audio Ready State:');
      this.isLoaded = true;
      this.dispatchEvent(AppEvent.LOAD_COMPLETE);
    }
    else {
      this.audio.onprogress = (ev) => {
        if (this.audio.buffered.length > 0) {
          const bufferedTime: number = this.audio.buffered.end(this.audio.buffered.length-1);
          const duration: number = this.audio.duration;
          this.buffered = bufferedTime / duration;
          if (this.buffered > 0.99) {
            this.buffered = 1;
            this.audio.onprogress = null;
          }
          // console.log('Buffered: ' + this.buffered);
        }
        
        const progressEvent: AppEvent = new AppEvent(AppEvent.LOAD_PROGRESS);
        console.log(this.buffered);
        progressEvent.buffered = this.buffered;
        this.dispatchEvent(progressEvent);
      };
      
      this.audio.oncanplaythrough = (ev) => {
        console.log('Can Play');
        this.audio.oncanplaythrough = null;
        this.onLoadComplete();
      };
    }
  }
  
  protected onLoadComplete = (): void => {
    this.audio.removeEventListener('canplaythrough', this.onLoadComplete);
    this.isLoaded = true;
    this.dispatchEvent(AppEvent.LOAD_COMPLETE);
  };
  
  set volume (value: number) {
    this._volume = value;
    this.audio.volume = this.basisVolume * this._volume;
  }
  get volume (): number { return this._volume; }
  
  
  set soundSrc (value: string) {
    this.audio.src = value;
  }
  get soundSrc (): string {
    return this.audio.src;
  }
  
  set currentTime (value: number) {
    this.audio.currentTime = value;
  }
  get currentTime (): number {
    return this.audio.currentTime;
  }
  
  get duration (): number {
    return this.audio.duration;
  }
  
  
  play = (): void => {
    this.audio.addEventListener('timeupdate', this.onTimeUpdate);
    this.audio.addEventListener('ended', this.onEnded);
    this.audio.play();
  };
  
  pause = (): void => {
    this.audio.removeEventListener('timeupdate', this.onTimeUpdate);
    this.audio.pause();
  };
  
  stop = (): void => {
    this.audio.removeEventListener('timeupdate', this.onTimeUpdate);
    this.audio.pause();
    this.audio.currentTime = 0;
  };
  
  mute = (): void => {
    this.audio.volume = 0;
  };
  
  clearMute = (): void => {
    this.audio.volume = this.basisVolume * this._volume;
  };
  
  onTimeUpdate = (ev: Event): void => {
    this.dispatchEvent(AppEvent.TIME_UPDATE);
  };
  
  onEnded = (ev: Event): void => {
    console.log('Music End');
    this.dispatchEvent(AppEvent.END);
  };
}
